import React from "react";
import { MessageCircle, Phone } from "lucide-react";

const PHONE_TEL = "tel:+447481626260";
const WA = "https://wa.me/447481626260?text=Hi%20Prime%20Build%2C%20I%27d%20like%20to%20discuss%20a%20project.";

export default function StickyContact() {
  return (
    <>
      {/* Sticky mobile-only call button (bottom-left) */}
      <a
        href={PHONE_TEL}
        aria-label="Call Prime Build Design"
        data-testid="sticky-call-mobile"
        className="lg:hidden fixed bottom-6 left-6 z-40 bg-slate-900 text-white w-14 h-14 rounded-full shadow-xl flex items-center justify-center hover:bg-slate-800 transition-colors"
      >
        <Phone size={22} />
      </a>

      {/* WhatsApp floating button (desktop + mobile) — positioned above the chat widget */}
      <a
        href={WA}
        target="_blank"
        rel="noreferrer"
        aria-label="Chat on WhatsApp"
        data-testid="whatsapp-floating"
        className="fixed bottom-40 right-6 z-40 bg-[#25D366] text-white w-14 h-14 rounded-full shadow-xl flex items-center justify-center hover:bg-[#1ebd5c] transition-colors"
      >
        <MessageCircle size={22} fill="currentColor" />
      </a>
    </>
  );
}
